import { ReactNode, ReactElement } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureBanner, IBanner } from 'mod/featureV2/interface/banner';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { FeatureWrapper } from 'mod/featureV2/FeatureWrapper';
import { IBannerProps } from 'mod/featureV2/Banner/interface';
import { GridBanner } from 'mod/featureV2/FeatureBanner/GridBanner';
import { CarouselBanner } from 'mod/featureV2/FeatureBanner/CarouselBanner';

export type IProps<T extends IBanner = IBanner> = IFeatureProps<IFeatureBanner<T>> & {
    containerWidth?: number;
    renderBanner?: (bannerProps: IBannerProps<T>) => ReactNode;
};

export function FeatureBanner<T extends IBanner = IBanner>(props: IProps<T>): ReactElement {
    const {
        feature: _feature,
        containerWidth,
        renderBanner,
        ...rest
    } = props;

    const feature = {
        // 默认消除上下 padding
        space: {
            paddingTop: 0,
            paddingBottom: 0
        },
        ..._feature,
        list: _feature.list.map(banner => ({
            ...banner,
            bgColor: banner.bgColor || _feature.config.bgColor
        }))
    };

    return (
        <FeatureContainer
            {...rest}
            feature={feature}
        >
            <FeatureWrapper config={feature.config}>
                {feature.config.type === 'carousel'
                    ? <CarouselBanner<T> {...props}/>
                    : <GridBanner<T> {...props}/>
                }
            </FeatureWrapper>
        </FeatureContainer>
    );
}